/*
 * @Descripttion:
 * @version:
 * @Author: Jianyong Wang
 * @Date: 2021-07-01 16:59:58
 * @LastEditors: zhangyang yang.zhang@corerain.com
 * @LastEditTime: 2023-03-15 15:46:39
 */
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import router from '@/router'
import { RouteLocationNormalized } from 'vue-router'
import store from '@/store'
import { RoleEnum } from '@/enums/roleEnum'

NProgress.configure({ showSpinner: false })
const whiteList = ['publish/auth', 'crrs-upload']

router.beforeEach(async (to: RouteLocationNormalized, _: RouteLocationNormalized, next: any) => {
  NProgress.start()

  const token = store.getters.token
  const userStore: any = store.state.user
  if (token) {
    if (to.path === '/login') {
      next('/')
    }
    // 用户信息不存在
    if (!userStore.hasGetCurUser) {
      await store.dispatch('user/fetchUser')
    }

    //  无权限
    const storeRole: any = userStore.role
    const routerName = to.name
    if (storeRole[routerName] === RoleEnum.NO_PERMISSION) {
      next('/welcome')
      NProgress.done()
      return
    }

    next()
  } else {
    if (whiteList.indexOf(to.path) !== -1 || to.meta.noAuth) {
      next()
    } else if (to.path === '/login') {
      next()
    } else {
      // next(`/login?redirect=${to.path}`)
      next(`/login`)
    }
  }

  NProgress.done()
})

router.afterEach((to: RouteLocationNormalized) => {
  ;(document as any).title = to?.meta?.title
})
